export default {
	install(Vue) {
		Vue.prototype.$parsePlainDate = (miliseconds) => {
			if (!miliseconds) {
				return '';
			}
			let date;
			// now = new Date();
			if (typeof miliseconds == 'string') date = new Date(parseInt(miliseconds));
			else date = new Date(miliseconds);
			if (isNaN(date.getTime())) {
				return "Unknown";
			} else {
				return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
			}
		}
		Vue.prototype.$parsePlainTime = (miliseconds) => {
			if (!miliseconds) {
				return '';
			}
			let date;
			// now = new Date();
			if (typeof miliseconds == 'string') date = new Date(parseInt(miliseconds));
			else date = new Date(miliseconds);
			if (isNaN(date.getTime())) {
				return "Unknown";
			} else {
				let hours = date.getHours() % 12;
				return `${hours == 0 ? 12 : hours}:${date.getMinutes() < 10 ? '0' : ''}${date.getMinutes()} ${date.getHours() > 11 ? 'PM' : 'AM'}`;
			}
		}
		Vue.prototype.$parsePlainTimeWithSec = (miliseconds) => {
			if (!miliseconds) {
				return '';
			}
			let date;
			// now = new Date();
			if (typeof miliseconds == 'string') date = new Date(parseInt(miliseconds));
			else date = new Date(miliseconds);
			if (isNaN(date.getTime())) {
				return "Unknown";
			} else {
				let hours = date.getHours() % 12;
				return `${hours == 0 ? 12 : hours}:${date.getMinutes() < 10 ? '0' : ''}${date.getMinutes()}:${date.getSeconds() < 10 ? '0' : ''}${date.getSeconds()} ${date.getHours() > 11 ? 'PM' : 'AM'}`;
			}
		}

		/*
		 * Convert time in ms to string based around current time
		 * 		- Same day  => hh:mm AM/PM
		 *      - Yesterday => yesterday
		 *      - Same week => Day of week
		 *      - Otherwise => MM/DD/YYYY
		 */
		Vue.prototype.$parseDate = (miliseconds) => {
			if (!miliseconds) {
				return '';
			}
			let date, now = new Date();
			if (typeof miliseconds == 'string') date = new Date(parseInt(miliseconds));
			else date = new Date(miliseconds);
			if (isNaN(date.getTime()))
				return "Unknown";
			if (date.getFullYear() == now.getFullYear()){
				if (date.getMonth() == now.getMonth()){
					// if ((date.getDate() - 7) > now.getDate()){
						if (date.getDate() == now.getDate()){
							let hours = date.getHours() % 12;
							return `${hours == 0 ? 12 : hours}:${date.getMinutes() < 10 ? '0' : ''}${date.getMinutes()} ${date.getHours() > 11 ? 'PM' : 'AM'}`;
						}
						if (date.getDate() + 1 == now.getDate()){
							return 'Yesterday';
						}
						if (date.getDate() > now.getDate()  &&  (date.getDate() < (now.getDate() + 7)) ) {
							return ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'][date.getDay() == 0 ?  6 : date.getDay()-1];
						}
						// return ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'][date.getDay() == 0 ?  6 : date.getDay()-1];
					// }
				}
			}
			return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
		}

		/*
		 *  Convert +1xxxxxxxxxx => (xxx) xxx-xxxx
		 *  or
		 *  Convert (xxx) xxx-xxxx => +1xxxxxxxxxx
		 */
		Vue.prototype.$parseNumber = (number) => {
			if (number) {
				if (number[0] == '+') {
					return `(${number.slice(2, 5)}) ${number.slice(5, 8)}-${number.slice(8)}`;
				} else if (number[0] == '(') {
					return `+1${number.slice(1, 4)}${number.slice(6, 9)}${number.slice(10)}`;
				}
			}
			return '';
		}

		/*
		 * Get name from prosp obj
		 */
		Vue.prototype.$parseAlias = (prosp) => {
			if (prosp) {
				return `${prosp.First} ${prosp.Last ? prosp.Last : ''}`;
			}
			return '';
		}
	}
}